module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/swim-icon-3b2182b3df3bfb157ac7835fc1d881e6.png";